import { useState, useEffect, useCallback } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getMyOfferCredits } from '../../api/walletApi';

const cyan = '#00e5ff';
const green = '#66ff99';

const fmtDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const OfferCredits = () => {
  const navigate = useNavigate();
  const [total, setTotal] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const load = useCallback(() => {
    setLoading(true);
    getMyOfferCredits({ page })
      .then((res) => {
        setTotal(res.data.total ?? 0);
        setTransactions(res.data.transactions || []);
        setPages(res.data.pages || 1);
      })
      .catch(() => {
        setTotal(0);
        setTransactions([]);
      })
      .finally(() => setLoading(false));
  }, [page]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <button
            onClick={() => navigate('/account-status')}
            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', color: '#888', borderRadius: 8, padding: '6px 14px', fontSize: 13, cursor: 'pointer' }}
          >
            ← Back
          </button>
          <div>
            <h4 style={{ color: '#fff', fontWeight: 700, margin: 0 }}>Offer Credits</h4>
            <div style={{ color: '#555', fontSize: 12, marginTop: 2 }}>Referral signup bonus credits</div>
          </div>
        </div>

        {/* Total chip */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, background: 'rgba(102,255,153,0.08)', border: '1px solid rgba(102,255,153,0.25)', borderRadius: 12, padding: '14px 24px' }}>
            <span style={{ color: '#555', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Total Offer Credits</span>
            <span style={{ color: green, fontSize: 26, fontWeight: 800, fontFamily: 'monospace' }}>
              {total !== null ? total.toFixed(2) : '—'} <span style={{ fontSize: 14, color: '#888' }}>USDT</span>
            </span>
          </div>
        </div>

        {/* Transaction list */}
        {!isMobile ? (
          <div style={{ background: '#111', border: '1px solid rgba(0,229,255,0.1)', borderRadius: 12, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'rgba(0,229,255,0.07)', borderBottom: '1px solid rgba(0,229,255,0.12)' }}>
                  {['#', 'Description', 'Amount (USDT)', 'Date'].map((h) => (
                    <th key={h} style={{ color: cyan, fontSize: 12, fontWeight: 600, padding: '12px 16px', textAlign: 'left', whiteSpace: 'nowrap' }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={4} style={{ color: '#555', textAlign: 'center', padding: 40, fontSize: 13 }}>Loading...</td></tr>
                ) : transactions.length === 0 ? (
                  <tr><td colSpan={4} style={{ color: '#555', textAlign: 'center', padding: 40, fontSize: 13 }}>No offer credits yet</td></tr>
                ) : (
                  transactions.map((t, i) => (
                    <tr
                      key={t._id}
                      style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(0,229,255,0.03)')}
                      onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                    >
                      <td style={{ color: '#555', fontSize: 12, padding: '12px 16px' }}>{(page - 1) * 20 + i + 1}</td>
                      <td style={{ color: '#ccc', fontSize: 13, padding: '12px 16px' }}>{t.comments}</td>
                      <td style={{ color: green, fontSize: 13, fontWeight: 700, padding: '12px 16px', fontFamily: 'monospace' }}>+{t.amount.toFixed(2)}</td>
                      <td style={{ color: '#555', fontSize: 11, padding: '12px 16px', whiteSpace: 'nowrap' }}>{fmtDate(t.createdAt)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {loading ? (
              <div style={{ color: '#555', textAlign: 'center', padding: 40 }}>Loading...</div>
            ) : transactions.length === 0 ? (
              <div style={{ color: '#555', textAlign: 'center', padding: 40 }}>No offer credits yet</div>
            ) : (
              transactions.map((t, i) => (
                <div key={t._id} style={{ background: '#111', border: '1px solid rgba(0,229,255,0.1)', borderRadius: 12, padding: '14px 16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ color: '#ccc', fontSize: 13, marginBottom: 4 }}>{t.comments}</div>
                      <div style={{ color: '#555', fontSize: 11 }}>{fmtDate(t.createdAt)}</div>
                    </div>
                    <div style={{ color: green, fontSize: 14, fontWeight: 800, fontFamily: 'monospace', whiteSpace: 'nowrap' }}>+{t.amount.toFixed(2)} USDT</div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Pagination */}
        {pages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20, flexWrap: 'wrap' }}>
            {Array.from({ length: Math.min(pages, 5) }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                onClick={() => setPage(p)}
                style={{
                  background: p === page ? cyan : 'rgba(255,255,255,0.06)',
                  border: 'none',
                  color: p === page ? '#000' : '#888',
                  borderRadius: 6,
                  padding: '6px 12px',
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {p}
              </button>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

export default OfferCredits;
